import React from "react";
import PropTypes from "prop-types";
import { ReadOnlyField } from "components/Shared";

export default function DisplayField(props) {
    const { displayField, ...rest } = props;
    delete rest.displayField;

    return (
        <ReadOnlyField 
            title={displayField.label}
            fieldValue={displayField.value}
            {...rest}
        />
    );
}

DisplayField.propTypes = {
    displayField: PropTypes.object,
};
